import { FC } from 'react';

import SendCommunicationModalHeader from './components/SendCommunicationModalHeader';
import SendCommunicationModalFooter from './components/SendCommunicationModalFooter';
import SendCommunicationModalBody from './components/SendCommunicationModalBody';

import { useSendCommunicationModal } from './context/SendCommunicationModalContext';

import CustomLoading from '../../CustomLoading';
import './SendCommunicationModal.scss';

const SendCommunicationModal: FC = () => {
  const { data } = useSendCommunicationModal();

  return (
    <div className="send-email-modal-container">
      <SendCommunicationModalHeader />

      <SendCommunicationModalBody />

      <SendCommunicationModalFooter />

      {data.isLoading && <CustomLoading />}
    </div>
  );
};

export default SendCommunicationModal;
